import { render } from "./EditDelivery.vue?vue&type=template&id=f3b2eba6"
import script from "./EditDelivery.vue?vue&type=script&lang=js"
export * from "./EditDelivery.vue?vue&type=script&lang=js"
script.render = render

export default script